import { render, staticRenderFns } from "./NewReport.vue?vue&type=template&id=7a45e2e9"
import script from "./NewReport.vue?vue&type=script&lang=js"
export * from "./NewReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports